(() => {
  if (window.__cbhCartRecommendationsBound) return;
  window.__cbhCartRecommendationsBound = true;

  const syncAddedProducts = (cartData) => {
    const items = Array.isArray(cartData?.items) ? cartData.items : [];
    const isEmpty = Number(cartData?.item_count ?? items.length) === 0;

    // The checkout-support panel is deliberately absent on an initially empty
    // basket. If the last line is removed via AJAX, hide the already-rendered
    // panel immediately rather than leaving checkout guidance below an empty cart.
    document.querySelectorAll('.cbh-section-cart-support').forEach((section) => {
      section.hidden = isEmpty;
    });

    if (isEmpty) return;

    const productIds = new Set(
      items
        .map((item) => item?.product_id ?? item?.productId)
        .filter((id) => id !== undefined && id !== null)
        .map(String)
    );

    if (!productIds.size) return;

    document.querySelectorAll('[data-cbh-cart-recommendation][data-product-id]').forEach((card) => {
      if (productIds.has(String(card.dataset.productId))) card.remove();
    });

    document.querySelectorAll('.cbh-cart-addons-pro slider-component').forEach((slider) => {
      slider.resetPages?.();
      const remaining = slider.querySelectorAll('[data-cbh-cart-recommendation]').length;
      const total = slider.querySelector('.slider-counter--total');
      if (total) total.textContent = String(remaining);

      if (!remaining) {
        const shopifySection = slider.closest('.shopify-section');
        if (shopifySection) shopifySection.hidden = true;
      }
    });
  };

  const bind = () => {
    const cartUpdateEvent = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null;
    if (typeof subscribe !== 'function' || !cartUpdateEvent) return false;
    subscribe(cartUpdateEvent, (event) => syncAddedProducts(event?.cartData));
    return true;
  };

  if (!bind()) {
    window.addEventListener('load', () => bind(), { once: true });
  }
})();
